<!-- eslint-disable -->
<template lang="pug">
    form.fields(action="javascript://", @submit="sendForm")
        template(v-if="user.isSuperadmin || user.type !== 'student'")
            .fields__element(v-if="filteredCourses.length > 1")
                label.fields__label {{ $i18n.t('fields.fields_pointsFor') }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="filteredCourses",
                    :show-labels="false",
                    :allow-empty="false",
                    :searchable="false",
                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                    v-model="form.course_type",
                    :custom-label="labelCourseType"
                )
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_school', 0) }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="schools",
                    :show-labels="false",
                    label="name",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingSchools",
                    @open="getSchools",
                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                    v-model="form.school"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_schoolNotFound') }}
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.tc('fields.fields_grade', 0) }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="grades",
                    :show-labels="false",
                    label="name",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingGrades",
                    :placeholder="gradesPlaceholder",
                    v-model="form.grade",
                    :disabled="isGradeDisabled",
                    @open="getGrades"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
            .fields__element
                label.fields__label.fields__label--small {{ $i18n.t('fields.fields_teacher') }}
                cs-multiselect.fields__input(
                    :multiple="false",
                    :options="teachers",
                    :show-labels="false",
                    track-by="id",
                    :searchable="true",
                    :loading="loadingTeachers",
                    :placeholder="teachersPlaceholder",
                    label="fullName",
                    v-model="form.teacher",
                    :disabled="isTeacherDisabled",
                    @open="getTeachers"
                )
                    span(slot="noResult") {{ $i18n.t('fields.fields_teacherNotFound') }}
            .fields__element
            .fields__element.fields__element--fluid
                cs-button(
                    color="blue",
                    pattern="primary-outline",
                    html-tag="a"
                    href="javascript://"
                    @click="resetResults",
                    narrow
                )
                    | {{ $i18n.t('fields.fields_dropParameters') }}
</template>

<script>
    /*eslint-disable*/
    import searchFieldsMixin from '../../../utils/searchFieldsMixin';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import searchParamsStore from '../utils/searchParamsStore';

    export default {
        mixins: [searchFieldsMixin, searchParamsStore],
        data() {
            return {
                courses: [],
                schools: [],
                grades: [],
                teachers: [],
                form: {
                    course_type: null,
                    school: null,
                    grade: null,
                    teacher: null,
                },
                allCourses: ['mentalArithmetic', 'russianLanguage'],
            };
        },
        watch: {
            '$route.query'(val) {
                if (_.isEmpty(val)) {
                    this.form = _.cloneDeep(this.localSearchParams) || {
                        course_type: null,
                        school: null,
                        grade: null,
                        teacher: null,
                    };
                }
            },
            'form.course_type'() {
                this.updateList();
            },
            'form.school'() {
                this.updateList();
            },
            'form.grade'() {
                this.updateList();
            },
            'form.teacher'() {
                this.updateList();
            },
        },
        props: ['schoolId', 'gradeId'],
        async mounted() {
            if (!this.user.isSuperadmin && this.user.type !== 'student') {
                await this.getCourses();
            }
            if (this.user.type === 'student') {
                this.form.course_type = this.selectedCourse;
            } else {
                this.form.course_type = this.filteredCourses[0];
            }
            this.sendForm();
        },
        methods: {
            sendForm() {
                let form = _.cloneDeep(this.form);
                this.$emit('search', form);
            },
            resetResults() {
                if (this.user.type === 'admin') {
                    if (this.user.isSuperadmin) {
                        this.form.school = null;
                    } else {
                        this.form.school = this.user.school;
                    }
                }
                this.form.grade = null;
                this.form.teacher = null;
                this.$emit('search', this.form);
            },
            updateList: _.debounce(function() {
                this.sendForm();
            }, 1000),
            labelCourseType(type) {
                return this.$i18n.t('common.common_points_for' + this.capitalizeFirstLetter(type));
            },
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
        },
        computed: {
            ...mapState({
                selectedCourse: state => state.trainer.course,
                user: state => state.auth.user,
            }),
            filteredCourses() {
                if (this.user.isSuperadmin) return this.allCourses;
                const coursesTypes = new Set(this.courses.map(({ type }) => _.camelCase(type)));
                return this.allCourses.filter(type => coursesTypes.has(type));
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../assets/sass/fields/fields.scss';
</style>
